module.exports = __webpack_public_path__ + "img/材料力学8_5_2.8e8ea26e.jpg";